/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationFormDto,
  PagedApplicationFormDto,
  ProblemDetails,
} from '../models/index';
import {
    ApplicationFormDtoFromJSON,
    ApplicationFormDtoToJSON,
    PagedApplicationFormDtoFromJSON,
    PagedApplicationFormDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface CreateApplicationFormTemplateRequest {
    applicationFormDto: Omit<ApplicationFormDto, 'commentCount'|'latestVersionNumber'|'reviewNotificationSent'|'sourceTemplateVersion'>;
}

export interface DeleteApplicationFormTemplateRequest {
    id: string;
}

export interface GetApplicationFormTemplateByIdRequest {
    id: string;
}

export interface UpdateApplicationFormTemplateRequest {
    id: string;
    applicationFormDto: Omit<ApplicationFormDto, 'commentCount'|'latestVersionNumber'|'reviewNotificationSent'|'sourceTemplateVersion'>;
}

/**
 * 
 */
export class ApplicationFormTemplateApi extends runtime.BaseAPI {

    /**
     * Create a new ApplicationFormTemplate
     */
    async createApplicationFormTemplateRaw(requestParameters: CreateApplicationFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['applicationFormDto'] == null) {
            throw new runtime.RequiredError(
                'applicationFormDto',
                'Required parameter "applicationFormDto" was null or undefined when calling createApplicationFormTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-form-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationFormDtoToJSON(requestParameters['applicationFormDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Create a new ApplicationFormTemplate
     */
    async createApplicationFormTemplate(requestParameters: CreateApplicationFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.createApplicationFormTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a ApplicationFormTemplate
     */
    async deleteApplicationFormTemplateRaw(requestParameters: DeleteApplicationFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteApplicationFormTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-form-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a ApplicationFormTemplate
     */
    async deleteApplicationFormTemplate(requestParameters: DeleteApplicationFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteApplicationFormTemplateRaw(requestParameters, initOverrides);
    }

    /**
     * Get all ApplicationFormTemplates
     */
    async getAllApplicationFormTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedApplicationFormDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-form-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Get all ApplicationFormTemplates
     */
    async getAllApplicationFormTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedApplicationFormDto> {
        const response = await this.getAllApplicationFormTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a specific ApplicationFormTemplate
     */
    async getApplicationFormTemplateByIdRaw(requestParameters: GetApplicationFormTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getApplicationFormTemplateById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-form-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Get a specific ApplicationFormTemplate
     */
    async getApplicationFormTemplateById(requestParameters: GetApplicationFormTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.getApplicationFormTemplateByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a ApplicationFormTemplate
     */
    async updateApplicationFormTemplateRaw(requestParameters: UpdateApplicationFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateApplicationFormTemplate().'
            );
        }

        if (requestParameters['applicationFormDto'] == null) {
            throw new runtime.RequiredError(
                'applicationFormDto',
                'Required parameter "applicationFormDto" was null or undefined when calling updateApplicationFormTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-form-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationFormDtoToJSON(requestParameters['applicationFormDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Updates a ApplicationFormTemplate
     */
    async updateApplicationFormTemplate(requestParameters: UpdateApplicationFormTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.updateApplicationFormTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
